import { render, staticRenderFns } from "./documentosTable.vue?vue&type=template&id=1f184d72"
import script from "./documentosTable.vue?vue&type=script&lang=js"
export * from "./documentosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports